// Models
import Model from './Model'

class Requisites extends Model {
  get isTypeFps () {
    return this.type === REQUISITES_TYPES.FPS
  }

  static getTypeOptions (currency) {
    if (currency === 'GBP') {
      return [
        { name: 'SEPA (Local)', value: REQUISITES_TYPES.SEPA },
        { name: 'SWIFT', value: REQUISITES_TYPES.SWIFT },
        { name: 'FPS/CHAPS', value: REQUISITES_TYPES.FPS }
      ]
    }

    return [
      { name: 'SEPA (Local)', value: REQUISITES_TYPES.SEPA },
      { name: 'SWIFT (International)', value: REQUISITES_TYPES.SWIFT },
      { name: 'FPS', value: REQUISITES_TYPES.FPS }
    ]
  }

  get schema () {
    return [
      'accountNumber',
      'bankAddress',
      'bankCountry',
      'bankName',
      'bankSwift',
      'bic',
      'correspondentBank',
      'currency',
      'inn',
      'intermediateBank',
      'localAccountNumber',
      'paymentDetails',
      'paymentDetailsRequirements',
      'providerType',
      'recipientAddress',
      'recipientCountry',
      'recipientName',
      'recipientRegNumber',
      'recipientType',
      'restrictedRegions',
      'sortCode',
      'specificTransferDetails',
      'type'
    ]
  }
}

export const REQUISITES_TYPES = {
  SWIFT: 'SWIFT',
  SEPA: 'SEPA',
  FPS: 'FPS'
}

export default Requisites
